import HeaderContent from "./layout/components/HeaderContent";
import React from "react";
import { Edit, EditProps, useEditController } from "react-admin";
import styled from "styled-components";

interface EditWrapperProps extends EditProps {
  breadcrumb: {
    link: string;
    title: string;
    params?: string;
  }[];
  isDefaultTitle?: boolean;
  isFullName?: boolean;
  customFieldName?: string;
  customNameWithId?: string;
  customResource?: string;
  customName?: {
    resourceName: string;
    propertyName: string;
  };
  children: React.ReactElement;
  isHaveSchoolFilter?: boolean;
}

const StyledEdit = styled(Edit)({
  "& .MuiCardContent-root": {
    padding: "24px 34px",
  },
  "& > div:first-child": {
    padding: "0px 0px 20px 0px",
  },
});

const EditWrapper: React.FC<EditWrapperProps> = (props) => {
  const {
    breadcrumb,
    isDefaultTitle,
    isFullName,
    customFieldName,
    customNameWithId,
    customResource,
    customName,
    children,
    isHaveSchoolFilter,
    ...editProps
  } = props;
  const controllerProps = useEditController(editProps);
  const { defaultTitle, record } = controllerProps;

  let headerTitle;

  if (isDefaultTitle) {
    headerTitle = defaultTitle;
  } else if (isFullName) {
    headerTitle = `${record?.firstName} ${record?.lastName}`;
  } else if (customFieldName && record) {
    headerTitle = record[customFieldName] || record.id;
  } else if (customNameWithId) {
    headerTitle = `${customNameWithId} #${record?.id || ""}`;
  } else if (customName) {
    headerTitle = `${customName.resourceName} - ${
      record[customName.propertyName] ?? ""
    }`;
  } else {
    headerTitle = record?.name || "";
  }

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle={headerTitle}
        isNotHaveSchoolFilter={!isHaveSchoolFilter}
        photoUrl={record?.photoUrl}
      />

      <StyledEdit {...editProps}>{children}</StyledEdit>
    </>
  );
};

export default EditWrapper;
